import { render, staticRenderFns } from "./ClientsHeader.vue?vue&type=template&id=775b4f0a&scoped=true&"
import script from "./ClientsHeader.vue?vue&type=script&lang=js&"
export * from "./ClientsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClientsHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClientsHeader.vue?vue&type=style&index=1&id=775b4f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775b4f0a",
  null
  
)

export default component.exports